import types from '../../config/types.js'
import MockPagination from './MockPagination.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [ServiceData, MockPagination],
  data() {
    return {
      searchTimeOut: null,
      filtersData: {
        page: 1,
        per_page: 10,
      },
      selectedGateCuid: null,
    }
  },
  computed: {
    filters() {
      return [
        {
          id: 'search',
          type: types.components.input,
          width: 4,
          attr: {
            placeholder: 'Поиск',
          },
        },
        {
          id: 'status',
          type: types.components.select,
          width: 2,
          attr: {
            placeholder: 'Статус',
            options: [
              {
                id: 0,
                label: 'Неактивный',
              },
              {
                id: 1,
                label: 'Активный',
              },
              {
                id: 2,
                label: 'Удалённый',
              },
            ],
          },
        },
      ]
    },
    tableColumns() {
      return [
        {
          id: '№',
          label: '№',
        },
        {
          id: 'server_type',
          label: 'Тип СКУД',
        },
        {
          id: 'issuer',
          label: 'Эмитент',
        },
        {
          id: 'status',
          label: 'Статус',
          onclick: () => {
            this.filtersData.order = 'status'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredBlePasses()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'status',
        },
        {
          id: 'hex8b',
          label: 'hex8b',
          onclick: () => {
            this.filtersData.order = 'hex8b'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredBlePasses()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'hex8b',
        },
        {
          id: 'dec3b',
          label: 'dec3b',
          onclick: () => {
            this.filtersData.order = 'dec3b'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredBlePasses()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'dec3b',
        },
        {
          id: 'qr_url',
          label: 'Ссылка',
        },
        {
          id: 'created_at',
          label: 'Дата создания',
          onclick: () => {
            this.filtersData.order = 'created_at'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredBlePasses()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'created_at',
        },
      ]
    },
    tableRows() {
      const data = []

      this.blePassList.forEach((blePass, index) => {
        data.push({
          id: blePass.ble_pass_id,
          columns: [
            {
              id: '№',
              content: {
                id:
                  index +
                  1 +
                  (this.blePassesMeta.current_page - 1) *
                    this.blePassesMeta.per_page,
                label:
                  index +
                  1 +
                  (this.blePassesMeta.current_page - 1) *
                    this.blePassesMeta.per_page,
              },
            },
            {
              id: 'server_type',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.server_type?.name || '-',
              },
            },
            {
              id: 'issuer',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.issuer?.name || '-',
              },
            },
            {
              id: 'status',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.status_label || '-',
              },
            },
            {
              id: 'hex8b',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.hex8b || '-',
              },
            },
            {
              id: 'dec3b',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.dec3b || '-',
              },
            },
            {
              id: 'qr_url',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.qr_url ? blePass.qr_url : '-',
                link: blePass.qr_url || null,
              },
            },
            {
              id: 'created_at',
              content: {
                id: blePass.ble_pass_id,
                label: blePass.created_at
                  ? new Date(blePass.created_at).toLocaleString('ru-RU', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  : '-',
              },
            },
          ],
        })
      })

      return data
    },
    actions() {
      return {
        default: [
          {
            id: 1,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Добавить BLE пропуска через файл',
              icon: 'plus-outlined',
              handler: () => this.onUploadBlePass(),
            },
          },
        ],
      }
    },
    blePassList() {
      return this.$store.getters.blePasses
    },
    blePassesMeta() {
      return this.$store.getters.blePassesMeta
    },
    currentGateCuid() {
      if (this.selectedGateCuid) {
        return this.selectedGateCuid
      }
      return this.$route.params.gateId || null
    },
    gateListOptions() {
      return this.gateList.map(gate => ({
        id: gate.cuid,
        label: gate.property.address,
      }))
    },
  },
  methods: {
    toggleColumnOrderType(column) {
      this.filtersData.order_type =
        this.filtersData.order === column &&
        this.filtersData.order_type === 'asc'
          ? 'desc'
          : 'asc'
    },
    onRowClick(rowId) {
      // Future implementation for row click if needed
    },
    async filterBlePasses(filters) {
      const cleanedFilters = Object.entries(filters).reduce(
        (acc, [key, value]) => {
          if (value !== '') {
            acc[key] = value
          }
          return acc
        },
        {}
      )

      this.filtersData = { ...cleanedFilters, page: 1, per_page: 10 }

      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(async () => {
        await this.getFilteredBlePasses()
      }, 500)
    },
    setBlePassesPagination() {
      this.initPagination(
        this.blePassesMeta.current_page,
        this.blePassesMeta.total,
        this.blePassesMeta.per_page
      )
    },
    async onSwitchPage(page) {
      this.filtersData.page = page
      await this.getFilteredBlePasses()
    },
    async getFilteredBlePasses() {
      if (!this.currentGateCuid) {
        return
      }

      this.filtersData.organization_id = this.currentOrganizationId
      await this.loadBlePasses(this.currentGateCuid, this.filtersData)
    },
    onUploadBlePass() {
      this.$emit('uploadBlePass')
    },
    async loadBlePasses(cuid, filters = {}) {
      await this.getBlePasses(cuid, filters)
      this.setBlePassesPagination()
    },
  },
  mounted() {},
}
